import { UDPGameClient } from './UDPGameClient';
import { ScoreDisplay } from '../components/ScoreDisplay';

export class GameScoring {
    private client: UDPGameClient;
    private score: number = 0;
    private scoreDisplay: ScoreDisplay;
    private isScoring: boolean = false;

    constructor(client: UDPGameClient) {
        this.client = client;
        this.scoreDisplay = new ScoreDisplay();
    }

    public startThirdPartyGameScoring() {
        if (!this.isScoring) {
            this.isScoring = true;
            console.log('Starting third party game scoring');
            this.scoreDisplay.show();
        }
    }

    public stopThirdPartyGameScoring() {
        if (this.isScoring) {
            this.isScoring = false;
            console.log('Stopping third party game scoring');
            // Keep the score visible after stopping
            // We're not hiding the score display anymore
            // this.scoreDisplay.hide();
        }
    }

    public addPoints(points: number) {
        if (!this.isScoring) return;
        
        this.score += points;
        console.log('Score updated:', this.score);
        
        // Update display
        this.scoreDisplay.updateScore(this.score);
        
        // Update player score in game state
        this.updatePlayerScore();
    }

    private updatePlayerScore() {
        // Get the current game data
        const gameState = this.client.getGameState();
        const playerId = this.client.getPlayerId();
        const currentPlayer = gameState.players[playerId];

        if (currentPlayer) {
            // Get existing game data or initialize with 0 score
            const currentGameData = currentPlayer.game_data || {};
            const currentTotalScore = currentGameData.totalScore || 0;
            
            // Update the game data with the new scores
            const updatedGameData = {
                ...currentGameData,
                score: this.score,
                totalScore: currentTotalScore + this.score
            };

            // Send the updated game data
            this.client.updatePosition(
                currentPlayer.position,
                currentPlayer.rotation,
                updatedGameData
            );
        }
    }

    public getScore(): number {
        return this.score;
    }

    public showScore() {
        this.scoreDisplay.show();
    }

    public hideScore() {
        this.scoreDisplay.hide();
    }

    public cleanup() {
        this.stopThirdPartyGameScoring();
        this.scoreDisplay.remove();
    }
} 